import {
  Autocomplete,
  Box,
  Grid,
  MenuItem,
  TextField,
  Tooltip,
} from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import ListItemText from '@mui/material/ListItemText'
import { useTheme } from '@mui/material/styles'
import { useQuery } from '@tanstack/react-query'
import { isValidUserInputMultipleFunctions } from 'OnlyWithFunctions'
import { StyledButton } from 'UI/StyledButton'
import { Roles } from 'enums/roles'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { getListaPraticheByCFAndRS } from 'services/getListaPratiche'
import { getListe } from '../../services/getListe'
import { getListaUtenzeAssegnatari } from '../../services/getListaUtenzeAssegnatari'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
}

// constants
const tipologiaDiRichiestaAlt = ['ADV ALTO RISCHIO MANUALE', 'ADV MEDIO RISCHIO MANUALE']

/*
// values from localStorage
const verificaRafforzataInRelazioneAlt = JSON.parse(localStorage.getItem('VerificaRafforzataInRelazioneA'))
const listaAutomaticaARAlt = JSON.parse(localStorage.getItem('MOTIVAZIONI_DELL_ADEGUATA_VERIFICA_RAFFORZATA_AUTOMATICA_AR_UTENTEINTERNO'))
const listaAutomaticaMRAlt = JSON.parse(localStorage.getItem('MOTIVAZIONI_DELL_ADEGUATA_VERIFICA_RAFFORZATA_AUTOMATICA_MR_UTENTEINTERNO'))
const listaMMR = JSON.parse(localStorage.getItem('motivazioniMMR'))
const listaMAR = JSON.parse(localStorage.getItem('motivazioniMAR'))

const tipologiaClienteAlt = JSON.parse(localStorage.getItem('TipologiaCliente'))
const daAssegnareA = JSON.parse(localStorage.getItem('DaAssegnareA'))
const listOptionalDocNames = JSON.parse(
  localStorage.getItem('DocumentiOpzionaliVari'),
)
*/

function AdeguataVerificaFormV2({
                                  handleSubmit,
                                  disabilitaBottoneSalva,
                                }) {
  const theme = useTheme()
  const disableDaAssegnareA = isValidUserInputMultipleFunctions([Roles.UTENTE_BASE.role, Roles.FIELD_ANALYST.role])

  const [verificaRafforzataInRelazioneAlt, setVerificaRafforzataInRelazioneAlt] = useState(JSON.parse(localStorage.getItem('VerificaRafforzataInRelazioneA')) || [])
  const [listaMMR, setListaMMR] = useState(JSON.parse(localStorage.getItem('motivazioniMMR')) || [])
  const [listaMAR, setListaMAR] = useState(JSON.parse(localStorage.getItem('motivazioniMAR')) || [])

  const [tipologiaClienteAlt, setTipologiaClienteAlt] = useState(JSON.parse(localStorage.getItem('TipologiaCliente')) || [])
  const [daAssegnareA, setDaAssegnareA] = useState(JSON.parse(localStorage.getItem('DaAssegnareA')) || [])
  const [listOptionalDocNames, setListOptionalDocNames] = useState(JSON.parse(
    localStorage.getItem('DocumentiOpzionaliVari'),
  ) || [])

  useEffect(() => {
    if (
      verificaRafforzataInRelazioneAlt.length === 0 ||
      listaMMR.length === 0 ||
      listaMAR.length === 0 ||
      tipologiaClienteAlt.length === 0 ||
      listOptionalDocNames.length === 0
    ) {
      getListe().then(response => {
        if (response.data.code === 200) {

          setVerificaRafforzataInRelazioneAlt(response.data.body.VERIFICA_RAFFORZATA_IN_RELAZIONE_A)
          setTipologiaClienteAlt(response.data.body.TIPOLOGIA_CLIENTE)
          setListaMAR(response.data.body.motivazioniMAR)
          setListaMMR(response.data.body.motivazioniMMR)
          setListOptionalDocNames(response.data.body.DOCUMENTI_OPZIONALI_VARI)

        }
      })
    }

    if (daAssegnareA.length === 0) {
      getListaUtenzeAssegnatari().then(response => {
        if (response.data && response.data.code === 200) {
          setDaAssegnareA(response.data.body || [])  // Aggiungi un fallback vuoto nel caso body non sia definito
        } else {
          console.error('Errore nella risposta del backend: ', response.data.message)
        }
      }).catch(error => {
        console.error('Errore durante la chiamata API: ', error)
      })

    }
  }, [])

  const {
    register,
    handleSubmit: handleSubmitFormValues,
    watch,
    getValues,
    setValue,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      documentiOpzionaliVari: [],
      motivazioniAdeguataVerifica: [],
      ragioneSociale: '',
      codiceFiscale: '',
      daAssegnare: !disableDaAssegnareA ? '' : JSON.parse(localStorage.getItem('user')),
    },
  })


  const [showNote, setShowNote] = useState(false)
  const [showDettaglioRelazione, setShowDettaglioRelazione] = useState(false)
  const [listRelazioneA, setListRelazioneA] = useState([])
  const [cfOrRsSelected, setCfOrRsSelected] = useState(false)

  const watchTipologiaDiRichiesta = watch('tipologiaDiRichiesta')

  useEffect(() => {
    const listRelazioni = [
      /*      {
              value: "ADV ALTO RISCHIO AUTOMATICA",
              lista: listaAutomaticaARAlt
            },
            {
              value: "ADV MEDIO RISCHIO AUTOMATICA",
              lista: listaAutomaticaMRAlt
            },*/
      {
        value: 'ADV ALTO RISCHIO MANUALE',
        lista: listaMAR,
      },
      {
        value: 'ADV MEDIO RISCHIO MANUALE',
        lista: listaMMR,
      },
      {
        value: '',
        lista: [],
      },
    ]

    const value = getValues('tipologiaDiRichiesta')

    const lista = listRelazioni.filter(rel => rel.value === value)[0].lista ? listRelazioni.filter(rel => rel.value === value)[0].lista : []

    setListRelazioneA(lista)

    setValue('motivazioniAdeguataVerifica', [])
  }, [getValues, setValue, watchTipologiaDiRichiesta])

  const watchMultiSelects = watch(['documentiOpzionaliVari', 'motivazioniAdeguataVerifica'])

  useEffect(() => {
    const valueDocumentiOpzionaliVari = getValues('documentiOpzionaliVari')
    setShowNote(valueDocumentiOpzionaliVari && valueDocumentiOpzionaliVari.length > 0)

    const valueMotivazioniAdeguataVerifica = getValues('motivazioniAdeguataVerifica')
    setShowDettaglioRelazione(valueMotivazioniAdeguataVerifica && valueMotivazioniAdeguataVerifica.length > 0 && (valueMotivazioniAdeguataVerifica.includes('Altro') || valueMotivazioniAdeguataVerifica.includes('Esito Monitoraggio')))
  }, [getValues, watchMultiSelects])

  const watchCodiceFiscaleAndRagioneSociale = watch(['codiceFiscale', 'ragioneSociale'])

  const {
    data: getListaPraticheByCFAndRSData,
  } = useQuery({
    queryFn: async () => {
      if (getValues('codiceFiscale') === '' && getValues('ragioneSociale') === '') {
        return []
      }
      return await getListaPraticheByCFAndRS(getValues('codiceFiscale'), getValues('ragioneSociale'))
    },
    queryKey: ['getListaPraticheByCFAndRS', watchCodiceFiscaleAndRagioneSociale],
    retry: false,
    refetchOnWindowFocus: false,
  })

  const remapDataCFAndRS = getListaPraticheByCFAndRSData ? getListaPraticheByCFAndRSData.map(adv => ({
    ...adv,
    label: `${adv.ragioneSociale} - ${adv.codiceFiscale}`,
  })) : []

  // Inizio parte Handlers

  const handleSelectionRSAndCF = (value) => {

    if (value !== null && value !== '') {
      const { ndg, codiceFiscale, nazione, indirizzo, citta, nomePratica, tipologiaCliente, ragioneSociale } = value
      setValue('ndg', ndg)
      setValue('codiceFiscale', codiceFiscale)
      setValue('nazione', nazione)
      setValue('indirizzo', indirizzo)
      setValue('citta', citta)
      setValue('nomePratica', nomePratica)
      setValue('tipologiaCliente', tipologiaCliente)
      setValue('ragioneSociale', ragioneSociale)
      setCfOrRsSelected(true)

    } else if (!value && cfOrRsSelected) {
      reset()
    }
  }

  const handleCheckErrors = () => {
    clearErrors()

    if (watchCodiceFiscaleAndRagioneSociale[0] === '') {
      setError('codiceFiscale', { type: 'required', message: 'Campo obbligatorio' })
    }

    if (watchCodiceFiscaleAndRagioneSociale[1] === '') {
      setError('ragioneSociale', { type: 'required', message: 'Campo obbligatorio' })
    }

    if (watch('motivazioniAdeguataVerifica').length === 0) {
      setError('motivazioniAdeguataVerifica', { type: 'required', message: 'Campo obbligatorio' })
    }
  }

  // const handleRequest

  // Fine parte Handlers

  return (
    <Box
      sx={{ backgroundColor: '#FFFFFF' }}
      alignContent="space-center"
      spacing={{ xs: 4, md: 2, lg: 2, xl: 2 }}
    >
      <form id="form-adeguata-verifica" onSubmit={(event) => {
        handleCheckErrors()
        return handleSubmitFormValues(handleSubmit)(event)
      }
      }>
        <Grid
          container
          padding="20px"
          spacing={{ xs: 4, md: 2, lg: 2, xl: 2 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          justifyItems="start"
        >
          <Grid item xs={3}>
            <TextField
              sx={{ width: '95%' }}
              name={'ndg'}
              error={errors.ndg}
              helperText={errors.ndg?.type === 'required' && 'Campo obbligatorio'}
              label={'NDG *'}
              id="standard-basic"
              variant="standard"
              margin="dense"
              {...register('ndg', { required: true, maxLength: 30 })}
            />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              name={'ragioneSociale'}
              id="standard-basic"
              label="Ragione Sociale *"
              variant="standard"
              options={remapDataCFAndRS}
              freeSolo
              value={watch('ragioneSociale')}
              onChange={(event, newValue) => {
                handleSelectionRSAndCF(newValue)
              }}
              sx={{
                '& .MuiInputBase-root .MuiInputBase-input': {
                  padding: '6px 12px',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{ width: '95%' }}
                  autoFocus
                  name={'ragioneSociale'}
                  error={errors.ragioneSociale}
                  helperText={errors.ragioneSociale?.type === 'required' ? 'Campo obbligatorio' : errors.ragioneSociale?.type === 'maxLength' ? 'Raggiunta lunghezza massima' : ''}
                  label={'Ragione Sociale *'}
                  variant="standard"
                  margin="dense"
                  onChange={(event) => {
                    setValue('ragioneSociale', event.target.value)
                    setCfOrRsSelected(false)
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <Autocomplete
              name={'codiceFiscale'}
              id="standard-basic"
              label="Codice Fiscale *"
              variant="standard"
              options={remapDataCFAndRS}
              freeSolo
              value={watch('codiceFiscale')}
              onChange={(event, newValue) => {
                handleSelectionRSAndCF(newValue)
              }}
              sx={{
                '& .MuiInputBase-root .MuiInputBase-input': {
                  padding: '6px 12px',
                },
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  sx={{ width: '95%' }}
                  autoFocus
                  name={'codiceFiscale'}
                  error={errors.codiceFiscale}
                  helperText={errors.codiceFiscale?.type === 'required' ? 'Campo obbligatorio' : errors.codiceFiscale?.type === 'maxLength' ? 'Raggiunta lunghezza massima' : ''}
                  label={'Codice Fiscale *'}
                  variant="standard"
                  margin="dense"
                  onChange={(event) => {
                    setValue('codiceFiscale', event.target.value)
                    setCfOrRsSelected(false)
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              sx={{ mt: 1, width: '95%' }}
              name={'nazione'}
              id="standard-basic"
              label="Nazione"
              variant="standard"
              {...register('nazione')}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              sx={{ mt: 1, width: '95%' }}
              name={'indirizzo'}
              id="standard-basic"
              label="Indirizzo"
              variant="standard"
              {...register('indirizzo')}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              sx={{ mt: 1, width: '95%' }}
              name={'citta'}
              id="standard-basic"
              label="Città"
              variant="standard"
              {...register('citta')}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              sx={{ mt: 1, width: '95%' }}
              name={'nomePratica'}
              id="standard-basic"
              label="Nome Pratica"
              variant="standard"
              {...register('nomePratica')}
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              select
              defaultValue=""
              sx={{ mt: 1, width: '95%' }}
              variant="standard"
              label="Tipologia cliente"
              inputProps={{
                name: 'tipologiaCliente',
                id: 'uncontrolled-native',
              }}
              {...register('tipologiaCliente')}
            >
              {tipologiaClienteAlt.map(name => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
        <Grid
          container
          padding="10px"
          paddingRight="20px"
          justifyContent={'end'}
          alignContent={'center'}
          sx={{
            backgroundColor: theme.palette.blue.light,
          }}
        >
          <Grid
            container
            paddingBottom={20}
            columns={{ xs: 4, sm: 8, md: 12 }}
            spacing={3}
            item
            xs={12}
            padding="15px"
            paddingTop={8}
            lineHeight={5}
          >
            <Grid item xs={4}>
              <TextField
                select
                sx={{ width: '100%' }}
                variant="standard"
                defaultValue=""
                error={errors.tipologiaDiRichiesta}
                label="Tipologia Richiesta"
                helperText={errors.tipologiaDiRichiesta?.type === 'required' && 'Campo obbligatorio'}
                inputProps={{
                  name: 'tipologiaDiRichiesta',
                  id: 'uncontrolled-native',
                }}
                {...register('tipologiaDiRichiesta', { required: true })}
              >
                {tipologiaDiRichiestaAlt.map(name => (

                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </TextField>

            </Grid>
            <Grid item xs={4}>
              <Tooltip
                title={
                  getValues('documentiOpzionaliVari').length > 0
                    ? getValues('documentiOpzionaliVari').join(', ')
                    : ''
                }
                placement="top"

              >
                <TextField
                  label="Documenti (Opzionali) Vari"
                  variant="standard"
                  size="none"
                  sx={{ width: '100%' }}
                  id="demo-multiple-checkbox"
                  select
                  defaultValue=""
                  MenuProps={MenuProps}
                  SelectProps={{
                    multiple: true,
                    value: getValues('documentiOpzionaliVari'),
                    onChange: (event) => setValue('documentiOpzionaliVari', event.target.value),
                    renderValue: selected => selected.join(', '),
                  }}
                >
                  {listOptionalDocNames?.map(name => (
                    <MenuItem key={name} value={name}>
                      <Checkbox
                        checked={getValues('documentiOpzionaliVari')?.indexOf(name) > -1}
                      />
                      {name}
                    </MenuItem>
                  ))}
                </TextField>
              </Tooltip>
            </Grid>
            <Grid item xs={4}>
              <TextField
                select
                defaultValue=""
                sx={{ width: '100%' }}
                variant="standard"
                label="Verifica rafforzata in relazione al seguente prodotto"
                inputProps={{
                  name: 'tipologiaOperativita',
                  id: 'uncontrolled-native',
                }}
                {...register('tipologiaOperativita')}
              >
                {verificaRafforzataInRelazioneAlt.map(name => (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={4}>
              <Tooltip
                title={
                  getValues('motivazioniAdeguataVerifica').length > 0
                    ? getValues('motivazioniAdeguataVerifica').join(', ')
                    : ''
                }
                placement="top"
              >
                <TextField
                  label="Motivazioni dell'adeguata verifica*"
                  variant="standard"
                  size="none"
                  sx={{ width: '100%' }}
                  id="demo-multiple-checkbox"
                  select
                  error={
                    errors.motivazioniAdeguataVerifica
                  }
                  disabled={getValues('tipologiaDiRichiesta') === '' && listRelazioneA.length === 0}
                  helperText={errors.motivazioniAdeguataVerifica?.type === 'required' ? 'Campo obbligatorio' : 'Inserire almeno una motivazione'}
                  MenuProps={MenuProps}
                  SelectProps={{
                    multiple: true,
                    value: getValues('motivazioniAdeguataVerifica'),
                    onChange: (event) => setValue('motivazioniAdeguataVerifica', event.target.value),
                    renderValue: selected => selected.join(', '),
                  }}
                >
                  {listRelazioneA?.map(name => (
                    <MenuItem key={name} value={name}>
                      <Checkbox checked={getValues('motivazioniAdeguataVerifica')?.indexOf(name) > -1} />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </TextField>
              </Tooltip>
            </Grid>

            <Grid item xs={4}>
              <Autocomplete
                name={'daAssegnare'}
                sx={{ width: '100%' }}
                id="standard-basic"
                label="Da assegnare a *"
                variant="standard"
                value={watch('daAssegnare')}
                disabled={disableDaAssegnareA}
                onChange={(event, newValue) => {
                  setValue('daAssegnare', newValue)
                }}
                options={daAssegnareA !== null ? daAssegnareA : []}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Da Assegnare a *"
                    fullWidth
                    variant="standard"
                    autoFocus
                    margin="none"
                    {...register('daAssegnare', { required: true })}
                    error={
                      errors.daAssegnare?.type === 'required' && 'Campo obbligatorio'
                    }
                    helperText={errors.daAssegnare?.type === 'required' && 'Campo obbligatorio'}
                  />
                )}
              />
            </Grid>
            <Grid item xs={4}>
              {showNote && (
                <textarea
                  aria-label="empty textarea"
                  onInvalid={(e) =>
                    e.currentTarget.setCustomValidity('Campo mancante')
                  }
                  onInput={(e) =>
                    e.currentTarget.setCustomValidity('')
                  }
                  placeholder="Motivazioni richieste opzionali*"
                  name={'motivazioneRichiesteOpzionali'}
                  minrows={3}
                  required
                  style={{
                    margin: '2px',
                    width: '100%',
                    maxWidth: '100%',
                    height: '40px',
                    maxHeight: '100%',
                    borderColor: 'black',
                  }}
                  {...register('motivazioneRichiesteOpzionali')}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              {showDettaglioRelazione && (
                <textarea
                  aria-label="empty textarea"
                  onInvalid={(e) =>
                    e.currentTarget.setCustomValidity('Completare Dettaglio relazione')
                  }
                  onInput={(e) =>
                    e.currentTarget.setCustomValidity('')
                  }
                  placeholder="Dettaglio Relazione"
                  name={'dettaglioRelazione'}
                  minrows={3}
                  required
                  style={{
                    margin: '2px',
                    width: '100%',
                    maxWidth: '100%',
                    height: '40px',
                    maxHeight: '100%',
                    borderColor: 'black',
                  }}
                  {...register('dettaglioRelazione')}
                />
              )}
            </Grid>
          </Grid>
          <Grid alignContent="end" item xs={12}>
            <StyledButton
              disabled={disabilitaBottoneSalva}
              sx={{ margin: 'auto', marginBottom: 'auto' }}
              type="submit"
            >
              SALVA
            </StyledButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  )
}

export default AdeguataVerificaFormV2
